import React,{useRef, useState, useEffect} from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Col, Row, Form, Nav, NavLink, Card, Button, ListGroup, Badge, Alert, Modal, Dropdown } from "react-bootstrap";
import Select from "react-select";
import SelectWrp from "../components/SelectWrp";
import Footer from "../layouts/Footer";
import Sidebar from "../layouts/Sidebar";
import DialogOwner from "../layouts/DialogOwner";
import LegendCircles from "../layouts/LegendCircles";
import PanelProject from "../layouts/PanelProject";
import Header from "../layouts/Header";
import {infoLayers} from "../data/Layers";
import { useContextMenu, Menu, Item } from 'react-contexify';

import "react-contexify/dist/ReactContexify.css";

import TurfCentroid from '@turf/centroid';
import TurfLength from '@turf/length';
import TurfCenterOfMass from '@turf/center-of-mass';
import TurfBBox from '@turf/bbox';
import TurfArea from '@turf/area';
import MapboxDraw from "@mapbox/mapbox-gl-draw";


import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import key from '../data/mapboxKey'; // eslint-disable-line import/no-webpack-loader-syntax

import {drawUtils} from "../utils/drawUtils";
import drawTheme from "../utils/drawUtilsTheme";
import vindrApi from "../utils/vindrapi";
import authApi from "../utils/authApi";
import turbineControl from "../utils/turbineControl";
import boundaryMode from "../utils/boundaryMode";
import limited_simple_select from "../utils/simple_select";
import limited_direct_select from "../utils/direct_select";
import Loader from "../components/Loader";
import DialogProject from "../layouts/DialogProject";
import DialogUploadLayer from "../layouts/DialogUploadLayer";
import {baseMaps} from "../data/baseMaps";
import UserMenu		from "../components/UserMenu";

mapboxgl.accessToken = key;

var du;  //drawutils
var tc;
var record;
var countries;


export default function Screening() {
		
		document.body.className="screening";
	
	const location = useLocation();

	const [errors,setErrors]			= useState(new Set()); //what layer to show, default show owners
	const [pageTitle,setPageTitle]		= useState('Project');
	const [pageSubTitle,setPageSubTitle]= useState('');
	const [loaded,setLoaded]			= useState(false); //status variable set when all data is loaded
	const [addProject,setAddProject]	= useState({open:false, boundary:null}); //displays new project dialog if true
	const [saveBtn,setSaveBtn]			= useState(false); //status variable set when all data is loaded
	const [uploadLayer,setUploadLayer]	= useState({open:false}); //displays uploadLayer dialog

	const mapContainer					= useRef(null);
	const map							= useRef(null);
	const [user,setUser]				= useState({});
	const [zoom, setZoom]				= useState(8);
	const [selectedBaseLayer, setSelectedBaseLayer]	= useState(null);
	const {show}  = useContextMenu({
		id: 'layer_opacity_control',
	});
	var center							= [];
	var projects						= {};	
	const mapStyles						= baseMaps;


	MapboxDraw.modes.simple_select = {...MapboxDraw.modes.simple_select, ...limited_simple_select};
	MapboxDraw.modes.direct_select = {...MapboxDraw.modes.direct_select, ...limited_direct_select};

	const Draw = new MapboxDraw({
		displayControlsDefault: false,
		controls: {
			polygon: false,
			line_string:false,
			trash: false,
			boundary_mode:true
		},
		userProperties:true,
		styles: drawTheme,
		modes: Object.assign({
			boundary_mode: boundaryMode,
		}, MapboxDraw.modes)
	});

	useEffect(()=>{
		getData();
	},[])	
	
	
	
	const getData = ()=>{ 
		
		
		Promise.all([vindrApi.getToken()])
		.then((res) => {
			
			const dataRequests = [
				vindrApi.getProjectsBoundaries(),
				vindrApi.getProjects(),
				authApi.getUser(),

			];
			return Promise.all(dataRequests);
		}).then((res)=>{
			
			var responses = res.map((response) => {
				if(response.json)
					return response.json();
				return response;
			});
			return Promise.all(responses);
		}).then((responses)=>{
			
			projects					= responses[0];
			var projectsInfo			= responses[1];
			var user					= responses[2];
			
			setUser(user);
			
			projects.features.map((f)=>{
				f.center = TurfCenterOfMass(f).geometry.coordinates;
				
				projectsInfo.find((p)=>{
					if(f.properties.projectid == p.projectid){
						f.owners = p.numLandowners;
						f.size = p.size;
						f.status = p.status;
					}
				});
				
			});
			
			
			center						= TurfCenterOfMass(projects).geometry.coordinates;
			
			document.title = process.env.REACT_APP_DOC_TITLE;
			renderMap();
			setLoaded(true);
		}).catch((e)=>{
			console.log(e);
			setLoaded(true);
			setErrors(p => [...p, 'Error fetching data']); //add this error to previous errors
		});
		return;

	};
	const showErrors = () => {
		if(errors.length) 
			return (<Alert variant="warning">{errors.map((m, k)=>{return <div key={k}>{m}</div>})}</Alert>) 
	}
	const renderMap = () => {
		if (map.current || errors.length)
			return; // initialize map only once
		map.current = new mapboxgl.Map({
			container: mapContainer.current,
			style: 'mapbox://styles/espenvindr/cljhhkw0z000901pq5tql7ice',
			center: center,
			zoom: zoom
		});
		map.current.addControl(Draw, 'bottom-left');
		
		map.current.dragRotate.disable();
		
		du		= new drawUtils(map.current, Draw);
		tc		= new turbineControl(map.current, du);
		
		map.current.on('draw.create', (e)=>setSaveBtn(true));
		map.current.on('draw.delete', (e)=>setSaveBtn(false));
		map.current.on('draw.modechange', du.handleModeChange.bind(du));
		//map.current.on('draw.actionable', (e)=>{console.log("actionable", e)});

		map.current.on('load', () => {
			
			du.drawProjects(projects);
			
			map.current.fitBounds(TurfBBox(projects));

			if (!map.current.getSource('projects-boundaries')) {
				map.current.addSource("projects-boundaries", {
					type: "geojson",
					data: projects
				});
				var z = map.current.addLayer({
					id: "projects-boundaries-stroke",
					type: "line",
					source: "projects-boundaries",
					paint: {
						'line-color': '#ff0000',
						"line-width": 2,
					}
				});
			}

	
			
			
		});
	}
	
	
	const drawProject = (e)=>{
		if(tc)
			tc.addProject(e);
	}
	
	
//	const openProjectDialog = (boundary)=>{
//		
//		var b = {...boundary};
//		
//		//convert polygon to multi
//		b.type = 'MultiPolygon';
//		b.coordinates = [boundary.coordinates];
//		
//		setAddProject({...addProject, open:true, boundary:b});
//				
//		
//	}
	const saveProject = (e)=>{
		
		var fc = du.draw.getAll();
		
		if(!fc.features || !fc.features.length)
			return;
		
		var b = {...fc.features[0].geometry};
		
		if(fc.features[0].geometry.type != 'MultiPolygon'){
			b.type = 'MultiPolygon';
			b.coordinates = [fc.features[0].geometry.coordinates];
		}
		setAddProject({...addProject, open:true, boundary:b});
	}
				
    const toggleSubMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest('.nav-item');
        parent.classList.toggle('show');

        //this.props.onUpdateSize();
    }

	const toggleInfoLayer = (e) => {

		if(e.target.checked){
			showInfoLayer(e.target.value, e.target.dataset);
		}
		else {
			hideInfoLayer(e.target.value);
		}

	}
	const showInfoLayer = (show, input) => {
		if(!show || !show.id) {
			infoLayers[input.country].forEach((section)=>{
				var found = section.layers.find(l=>l.id == show) ;
				if(found)
					show = found;
			});
		}
		if(!map.current.getSource(show.id)){
			map.current.addSource(show.id, show.source);

			//set the opacity if there is a preset
			map.current.addLayer(show.layer);
			if(input)
				du.setLayerOpacity(show.layer.id, input.opacity)
			du.stackLayer(show.layer.id);
		}

	}
	const hideInfoLayer = (layer)=>{
		map.current.removeLayer(layer+'-layer');
		map.current.removeSource(layer);

	}
	const showOpacityControl = (e)=>{
	
		var input = e.currentTarget.querySelector("INPUT");
		if(input && input.checked && input.dataset && input.dataset.layer){
			du.currentSelectedLayer = input.dataset;
			show({
				event:e
			});
			
			du.setRangeOpacity();
			
		}
	
	}
	const dialogOpacity = ()=>{
		if(du)
			return du.drawOpacityPanel();
	}
	const changeBaseLayer = (layer, onDone) => {
		
		setSelectedBaseLayer({...{label:mapStyles[layer.value].label}, ...layer});
		
		map.current.currentStyle = mapStyles[layer.value];
		
		map.current.setStyle(mapStyles[layer.value].value, {diff:false});
		
		map.current.once('style.load', ()=>{
			if(map.current.currentStyle.layer)
				showInfoLayer(map.current.currentStyle.layer);



			if(onDone instanceof Function)
				onDone();
			
			redrawInfoLayers();

			du.syncLayerOpacity();
		});
	}
	const redrawInfoLayers = () => {
		
		var countries = infoLayers.countries();

		countries.forEach((country)=>{
			country.sections.forEach((section)=>{
				section.layers.forEach((layer)=>{
					if(document.getElementById("checkbox_"+layer.id).checked){
						map.current.addSource(layer.id, layer.source);
						map.current.addLayer(layer.layer);
						//du.stackLayer(layer.id);
						map.current.moveLayer(layer.layer.id, 'gl-draw-polygon-fill-inactive.cold');
					}
				}) ;
			});			
			
		});
		

	}
	const toggleMarker = (e) => {
		map.current.getContainer().classList[!e.target.checked ? 'add':'remove'](e.target.dataset.class);
		return true;
	}
	
	const handleLayerUpload = (layer)=>{
		
		if(du && layer.features && layer.features.length){
			
			var feature = {...layer.features[0]};
			
			const center = TurfCenterOfMass(feature.geometry).geometry.coordinates;
			
			
			feature.id = 'boundary';
			
			
			du.draw.add(feature);
			setSaveBtn(true);
			map.current.fitBounds(TurfBBox(feature));
		}
		
	}
	const getLayers = (l)=> {
		
		countries = l.countries();
		
		
		return countries.map((country,h)=>{
			
			return (
				
				<li key={h} className="pb-3">
					<strong>{country.name}</strong>	
					{
						country.sections.map((section, k)=>{
							return (
								<ul key={k} className="nav nav-sidebar pb-0 ps-3">
									<li key={k} className={'nav-item '+(section.defaultOpen ? 'show' : '')}>

										<div onClick={toggleSubMenu} className="nav-link has-sub" title={section.name}><i className={section.icon}></i> <span>{section.name.length > 22 ? section.name.substring(0, 22) + "..." : section.name}</span></div>
										<nav className="nav nav-sub">
										{
											section.layers.map((layer, j)=>{
												return (
												<Row key={j} onContextMenu={showOpacityControl}>

													<Col xs="9">
														{layer.name}
													</Col>
													<Col xs="3">
														<Form.Check id={"checkbox_"+layer.id} value={layer.id} data-layer={layer.id+'-layer'} data-country={country.name} onClick={toggleInfoLayer} type="switch" defaultChecked={layer.defaultChecked ? "checked" : ""} />
													</Col>

												</Row>
												)
											})
										}
										</nav>
									</li>
								</ul>
							)
						})
					}
				</li>
			)
		});


	}
	const ProjectsSidebar = () => {
		
		return (
			<React.Fragment>

			<div className="nav-group project-panel show">
				<Row className="layer-section">
					<Col xs="12" className="mb-3">
						<small>Base layer</small>
					</Col>
					<Select value={selectedBaseLayer} options={mapStyles.map((v,k)=>{return {"label":v.label,"value":k}})} onChange={changeBaseLayer}  isSearchable={false} />
				</Row>
				<ul className="nav nav-sidebar">
					<li className="pb-3">
						<strong>Filters</strong>
						
						<ul className="nav nav-sidebar pb-0 ps-3">
							<li className="nav-item show">

								<div onClick={toggleSubMenu} className="nav-link has-sub" title="Energy type"><i className="ri-lightbulb-flash-line"></i> <span>Energy type</span></div>
								<nav className="nav nav-sub">
										<Row>

											<Col xs="9">
												Wind
											</Col>
											<Col xs="3">
												<Form.Check onClick={toggleMarker} data-class="hide-wind"  type="switch" defaultChecked={true} />
											</Col>
										</Row>
										<Row>

											<Col xs="9">
												Solar
											</Col>
											<Col xs="3">
												<Form.Check onClick={toggleMarker} data-class="hide-solar" type="switch" defaultChecked={true} />
											</Col>
										</Row>

								</nav>
							</li>
						</ul>

					</li>
						
						
					{getLayers(infoLayers)}
				</ul>



				<Menu id="layer_opacity_control">
					<Item>{dialogOpacity()}</Item>
				</Menu>
			</div>
			</React.Fragment>
		);
	}



	return (
		<React.Fragment>
	
			<div className="header">
			
				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>
				
				
				<div className="middle">
					

					<Link to="/" className="header-logo">Site Planner</Link>
					
				</div>
				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/vindr_logo_blue.svg" alt="Vindr"/>
				</div>
				<div className="options">
						{user.userId && <UserMenu user={user} onUpdateUser={setUser} />}
						
				</div>
			</div>
			
			<div className="body">

				<Sidebar add={ProjectsSidebar()} />
				<div className="main p-4 p-lg-5 map-wrapper">
					{showErrors()}


					<div ref={mapContainer}  className="project-map" />
						<DialogProject user={user} state={addProject} onClose={()=>{setAddProject(false)}} />

						<div className="screening-cp">
							<Button className="add-project" onClick={(e)=>drawProject(e)} variant="light">Draw project <img width="24" src="/images/icons/add_boundary.svg" />  </Button>
							<Button className="upload-project" onClick={(e)=>setUploadLayer({open:true})} variant="light">Upload project <i className="ri-upload-2-line"></i> </Button>
							{
							saveBtn && <Button className="add-project" onClick={(e)=>saveProject(e)} variant="success">Save project  <i className="ri-save-line"></i>   </Button>
							}

						</div>
						<DialogUploadLayer setup={uploadLayer} title="Upload project" type="convertLayer" onUpload={(layer)=>{handleLayerUpload(layer);}} onClose={()=>{setUploadLayer({open:false});}} />
					
				</div>
			</div>
			
			
			<Loader loaded={loaded} message="Loading project..." />
			  
			  
		</React.Fragment>
	);
}


